/**
 * @description 查詢勘車拍照步驟用參數
*/
export enum SurveyVehiclePClass {
    CARSURVEYGRP = 'CARSURVEYGRP',
    CARSURVEY='CARSURVEY'
}
